import { CallSimulationConstants } from '../Constants';
import { adminUsersServices } from '../Services';

export const callSimuationActions = {
    searchCallSimulation
};

function searchCallSimulation(data:any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: CallSimulationConstants.SEARCH_CALLSIMULATION_REQUEST,
            data: null
        }));
        adminUsersServices.callSimuation(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: CallSimulationConstants.SEARCH_CALLSIMULATION_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: CallSimulationConstants.SEARCH_CALLSIMULATION_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: CallSimulationConstants.SEARCH_CALLSIMULATION_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}